<template>
    <el-button-group :class="customClass">
        <el-button 
            size="small"
            icon="el-icon-check"
            @click="onSelectAll"
        >
            Select All
        </el-button>
        <el-button 
            size="small"
            icon="el-icon-close"
            @click="onClearSelection"
        >
            Clear Selection
        </el-button>
    </el-button-group>
</template>

<script>
export default {
    name: 'ElSelectBulkActions',

    props: {
        customClass: {
            type: String,
            required: false,
            default: '',
        },
    },

    methods: {
        onSelectAll() {
            this.$emit('selectAll')
        },

        onClearSelection() {
            this.$emit('clearSelection')
        },
    }
}
</script>
